(function() {
  var InviteTab, ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ValidationEngine = App.loadClass("core::ValidationEngine");

  InviteTab = App.loadClass("grower::handlers/contacts/tabs/Invite_Tab_Handler");

  exports.Add_Permission_Dialog = (function(superClass) {
    extend(Add_Permission_Dialog, superClass);

    function Add_Permission_Dialog() {
      return Add_Permission_Dialog.__super__.constructor.apply(this, arguments);
    }

    Add_Permission_Dialog.prototype.init = function() {
      var ths;
      ths = this;
      this.layoutUrl = 'backend/grower/contacts/addpermissionform';
      this.classes = 'large_dialog';
      this.saveUrl = 'backend/grower/contacts/addpermission-ajax';
      this.refreshNavHandler = false;
      this.validator = new ValidationEngine();
      this.successAction = function(data) {
        var i, ref, results, v;
        ref = App.current_page.activeSubHandlers;
        results = [];
        for (i in ref) {
          v = ref[i];
          if (v instanceof InviteTab) {
            results.push($(v.layoutSelector).find('.btn-search').click());
          } else {
            results.push(App.current_page.refreshSubHandlers());
          }
        }
        return results;
      };
      return this.createDialog();
    };

    Add_Permission_Dialog.prototype.afterLoadLayout = function() {
      var self;
      self = this;
      this.openDialog();
      this.getPermission(null, function() {
        return self.setPosition();
      });
      this.validator.makeFormValidator('addPermission', '#frm_addpermission', '#errorDiv', (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.save('Adding New Permission...');
          }
        };
      })(this));
      this.validator.registerRule({
        'selector': '.validate-permission',
        'text': 'The permission name you entered needs to be unique from your other permission names.',
        'ajax': {
          'url': 'backend/grower/contacts/validate-permission',
          'data': function(elem) {
            return {
              'permission_name': elem.val()
            };
          }
        },
        'func': function(data) {
          return data === 'valid';
        }
      });
      return this.submitAction = (function(_this) {
        return function() {
          return _this.validator.validateAll();
        };
      })(this);
    };

    Add_Permission_Dialog.prototype.getPermission = function(id, callback) {
      var idv;
      if (id == null) {
        id = null;
      }
      if (callback == null) {
        callback = null;
      }
      this.dialog.find('.message_writer').message_writer('info', 'Loading...');
      idv = id ? {
        id: id
      } : null;
      return $.post('backend/grower/contacts/get-permissionform-ajax', idv, (function(_this) {
        return function(response) {
          var cdata, render;
          cdata = response.data;
          render = _this.dialog.find(".permissions-template").render(cdata);
          _this.dialog.find('.permissions-table-wrapper').html(render);
          _this.dialog.find('#frm_addpermission').show();
          _this.dialog.find('.message_writer').message_writer('success', 'Loaded');
          _this.dialog.find('.message_writer').message_writer('hide');
          _this.dialog.find('.multi-control').click(function(e) {
            var affect, affectClass, checkboxes, table, unchecked;
            if ($(this).is('.view')) {
              affectClass = '.con_addView';
            } else if ($(this).is('.add')) {
              affectClass = '.con_addAdd';
            }
            affect = affectClass + " :checkbox";
            table = $(this).parents('table');
            checkboxes = $(table).find(affect);
            unchecked = false;
            checkboxes.each(function() {
              if (!$(this).prop('checked')) {
                unchecked = true;
                return $(this).prop('checked', true);
              }
            });
            if (!unchecked) {
              return checkboxes.each(function() {
                return $(this).prop('checked', false);
              });
            }
          });
          return typeof callback === "function" ? callback() : void 0;
        };
      })(this));
    };

    return Add_Permission_Dialog;

  })(DialogHandler);

}).call(this);
